import { useEffect, useRef, useState } from "react";

import IsLogin from "../../utilities/functions/isLogin";
import { useLocation, useNavigate } from "react-router-dom";
import apiConfig from "../../utilities/apiConfig.json";
import serverConfig from "../../utilities/serverConfig.json";
import constData from "../../utilities/const.json";
import axios from "axios";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import PlaceCard from "./placeCard";
import DepartmentPlaceCard from "../department/departmentPlaceCard";
import PlaceImgNotFound from "./../../assets/images/place-not-found.svg";
import isWhitespaceString from "../../utilities/functions/isWhiteSpaceString";
import { useDispatch, useSelector } from "react-redux";
import { setUser } from "../../slices/userSlice";
import haveAccess from "../../utilities/functions/haveAccess";
import AddIcon from "./../../assets/images/icons/Google SVGs/add.svg";
import { ReactComponent as ArrowRightAltIcon } from "./../../assets/images/icons/Google SVGs/arrow_right_alt.svg";
import { ReactComponent as DeleteIcon } from "./../../assets/images/icons/Google SVGs/delete.svg";
import scrollToTop from "../../utilities/functions/ScrollToTop";
import PlaceSkt from "../../components/Skeletons/PlaceSkt";
import CreatePlaceSkt from "../../components/Skeletons/CreatePlaceSkt";

const depositOptions = [
    { value: "", label: "درصد بیعانه را انتخاب کنید", disabled: true },
    { value: "0", label: "0" },
    { value: "30", label: "30%" },
    { value: "50", label: "50%" },
    { value: "100", label: "100%" },
];

const PlaceStore = () => {

    const [logIn, setLogIn] = useState();
    const navigate = useNavigate();
    const departmentSearchInputRef = useRef(null); // Reference to the input field

    const dispatch = useDispatch();
    const { token, roles } = useSelector((state) => state.user);
    const tokenLocal = localStorage.getItem("token");

    const headers = { Authorization: "Bearer " + (token ? token : tokenLocal) };

    // #endregion
    const [loading, setLoading] = useState(false);

    const [clearData, setClearData] = useState(false);
    const [editing, setEditing] = useState(false);
    const [placeID, setPlaceID] = useState();

    const [places, setPlaces] = useState();

    const { search } = useLocation();
    const queryParams = new URLSearchParams(search);
    const pl = queryParams.get("pl") ? queryParams.get("pl") : null; // Getting the value of 'pl' from the query string
    const action = queryParams.get("action") ? queryParams.get("action") : null; // Getting the value of 'action' from the query string

    // #region pages variables
    const [searchValue, setSearchValue] = useState("");
    const [paginationElem, setPaginationElem] = useState();
    const [currentPage, setCurrentPage] = useState(1);
    const [pageCount, setPageCount] = useState(0);
    const [perPage, setPerPage] = useState(24);
    //  #endregion

    // #region city province
    const [cities, setCities] = useState();
    const [provinces, setProvinces] = useState();
    const [selectedCity, setSelectedCity] = useState("");
    const [selectedProvince, setSelectedProvince] = useState("");
    const [selectedDeposit, setSelectedDeposit] = useState("");
    // #endregion

    // #region assign dep to place
    const [departments, setDepartments] = useState([]);
    const [departmentsList, setDepartmentsList] = useState([]);
    const [department, setDepartment] = useState({
        id: null,
        title: null,
        biography: null,
    });
    const [departmentSearch, setDepartmentSearch] = useState("");

    // data for add dep
    const [allDepartments, setAllDepartments] = useState();

    const [departmentBio, setDepartmentBio] = useState("");
    const [departmentPhone, setDepartmentPhone] = useState("");
    // #endregion

    // #region edit Department Place
    const [departmentEdit, setDepartmentEdit] = useState({
        id: null,
        title: null,
        biography: null,
        phone: null,
    });
    const [modalEditDepartmentPlaceShow, setModalEditDepartmentPlaceShow] =
        useState(false);
    // #endregion

    // #region creation input

    const [isActive, setIsActive] = useState(0);
    const [preview, setPreview] = useState();
    const [placePhoto, setPlacePhoto] = useState();
    const [placeName, setPlaceName] = useState("");
    const [pazirexPatientServiceAmount, setpazirexPatientServiceAmount] = useState("");
    const [pazirexProviderServiceAmount, setpazirexProviderServiceAmount] = useState("");
    const [totalVisitAmount, setTotalVisitAmount] = useState("");//
    const [address, setAddress] = useState("");
    const [placeType, setPlaceType] = useState("");
    const [technicalPhoneNumber, setTechnicalPhoneNumber] = useState("");
    const [biography, setBiography] = useState("");
    // #endregion

    const placePhotoChangeHandler = (e) => {
        setPlacePhoto(e);
    };

    const placeNameChangeHandler = (e) => {
        setPlaceName(e);
    };
    const pazirexPatientServiceAmountChangeHandler = (e) => {
        setpazirexPatientServiceAmount(e);
    };
    const pazirexProviderServiceAmountChangeHandler = (e) => {
        setpazirexProviderServiceAmount(e);
    };
    const totalVisitAmountChangeHandler = (e) => {
        setTotalVisitAmount(e);
    };

    const addressChangeHandler = (e) => {
        setAddress(e);
    };

    const technicalPhoneNumberChangeHandler = (e) => {
        setTechnicalPhoneNumber(e);
    };

    const placeStoreAPI = () => {
        // create a new FormData object and append the file to it
        setLoading(true);
        const formData = new FormData();
        formData.append("title", placeName);
        formData.append("province_id", selectedProvince);
        formData.append("city_id", selectedCity);
        formData.append("address", address);
        formData.append("technical_phone", technicalPhoneNumber);
        formData.append("type", placeType);
        formData.append("biography", biography);
        formData.append("is_active", isActive);
        formData.append("deposit_percentage", selectedDeposit);
        formData.append("pazirex_patient_service_amount", pazirexPatientServiceAmount);
        formData.append("pazirex_provider_service_amount", pazirexProviderServiceAmount);
        formData.append("total_visit_amount", totalVisitAmount);

        if (placePhoto) {
            formData.append("files[]", placePhoto.target.files[0]);
        }

        // make a POST request to the File Upload API with the FormData object and Rapid API headers
        axios
            .post(
                serverConfig.server.url + apiConfig.api.storeAPIs.storePlace,
                formData,
                {
                    headers,
                }
            )
            .then((response) => {
                setLoading(false);
                if (response.data.status === "success") {
                    toast.success(response.data.message);
                    setClearData(true);
                    getPlacesAPI();
                    navigate("/place-store");
                } else {
                    if (typeof response.data.errors === typeof "String") {
                        toast.error(response.data.errors);
                    } else {
                        response.data.errors.forEach((element) => {
                            toast.error(element);
                        });
                    }
                }
            })
            .catch((error) => {
                setLoading(false);
                toast.error("Error making API call:", error);
            });
    };

    const placeUpdateAPI = () => {
        setLoading(true);
        // create a new FormData object and append the file to it
        const formData = new FormData();
        formData.append("title", placeName);
        formData.append("province_id", selectedProvince);
        formData.append("city_id", selectedCity);
        formData.append("address", address);
        formData.append("technical_phone", technicalPhoneNumber);
        formData.append("type", placeType);
        formData.append("biography", biography);
        formData.append("is_active", isActive);
        formData.append("deposit_percentage", selectedDeposit);
        formData.append("pazirex_patient_service_amount", pazirexPatientServiceAmount);
        formData.append("pazirex_provider_service_amount", pazirexProviderServiceAmount);
        formData.append("total_visit_amount", totalVisitAmount);
        if (placePhoto) {
            formData.append("files[]", placePhoto.target.files[0]);
        }

        // make a POST request to the File Upload API with the FormData object and Rapid API headers
        axios
            .post(
                serverConfig.server.url +
                apiConfig.api.updateAPIs.updatePlace +
                placeID,
                formData,
                {
                    headers,
                }
            )
            .then((response) => {
                setLoading(false);
                if (response.data.status === "success") {
                    toast.success(response.data.message);
                    setEditing(false);
                    setClearData(true);
                    getPlacesAPI();
                    navigate("/place-store");
                } else {
                    if (typeof response.data.errors === typeof "String") {
                        toast.error(response.data.errors);
                    } else {
                        response.data.errors.forEach((element) => {
                            toast.error(element);
                        });
                    }
                }
            })
            .catch((error) => {
                setLoading(false);

                toast.error("Error making API call:", error);
            });
    };

    const placeDeleteAPI = () => {
        setLoading(true);
        axios
            .get(
                serverConfig.server.url +
                apiConfig.api.deleteAPIs.deletePlace +
                placeID,
                {
                    headers,
                }
            )
            .then((response) => {
                setLoading(false);
                if (response.data.status === "success") {
                    toast.success(response.data.message);
                    setEditing(false);
                    setClearData(true);
                    getPlacesAPI();
                    navigate("/place-store");
                } else {
                    if (typeof response.data.errors === typeof "String") {
                        toast.error(response.data.errors);
                    } else {
                        response.data.errors.forEach((element) => {
                            toast.error(element);
                        });
                    }
                }
            })
            .catch((error) => {
                setLoading(false);

                toast.error("Error making API call:", error);
            });
    };

    const stateAPI = () => {
        setLoading(true);
        axios
            .get(
                serverConfig.server.url + apiConfig.api.publicAPIs.getProvincesAndCities
            )
            .then((response) => {
                setLoading(false);
                if (response.data.status === "success") {
                    setProvinces(response.data.data.provinces);
                    setCities(response.data.data.cities);
                } else {
                    if (typeof response.data.errors === typeof "String") {
                        toast.error(response.data.errors);
                    } else {
                        response.data.errors.forEach((element) => {
                            toast.error(element);
                        });
                    }
                }
            })
            .catch((error) => {
                setLoading(false);
                console.error("Error making API call:", error);
            });
    };

    const getPlacesAPI = () => {
        setLoading(true);
        axios
            .post(
                serverConfig.server.url +
                apiConfig.api.getAPIs.getPlaces +
                "?page=" +
                currentPage,
                {
                    per_page: perPage,
                    ...(isWhitespaceString(searchValue) && { search_value: searchValue }),
                    pagination: true,
                },
                { headers }
            )
            .then((response) => {
                setLoading(false);
                if (response.data.status === "success") {
                    response.data.data.places && setPlaces(response.data.data.places);

                    // pagination
                    setPaginationElem();
                    setPageCount(response.data.data.page_count);
                    for (let i = 1; i <= response.data.data.page_count; i++) {
                        setPaginationElem((prevPaginationElem) => (
                            <>
                                {prevPaginationElem}
                                <li
                                    className={"page-item" + (currentPage == i ? " active" : "")}
                                >
                                    <a
                                        className="page-link"
                                        href="#"
                                        onClick={() => {
                                            setCurrentPage(i);
                                            scrollToTop();
                                        }}
                                    >
                                        {i}
                                    </a>
                                </li>
                            </>
                        ));
                    }
                } else {
                    if (typeof response.data.errors === typeof "String") {
                        toast.error(response.data.errors);
                    } else {
                        response.data.errors.forEach((element) => {
                            toast.error(element);
                        });
                    }
                }
            })
            .catch((error) => {
                setLoading(false);
                toast.error("Error making API call:", error);
            });
    };

    const getPlaceProfileAPI = () => {
        setLoading(true);
        axios
            .get(serverConfig.server.url + apiConfig.api.getAPIs.getPlace + placeID, {
                headers,
            })
            .then((response) => {
                setLoading(false);
                if (response.data.status === "success") {
                    setPlaceName(response.data.data.place.title);
                    setPlaceType(response.data.data.place.type);
                    setSelectedProvince(response.data.data.place.province_id);
                    setSelectedCity(response.data.data.place.city_id);
                    setAddress(response.data.data.place.address);
                    setTechnicalPhoneNumber(response.data.data.place.technical_phone);
                    if (response.data.data.place.biography)
                        setBiography(response.data.data.place.biography);
                    else setBiography("");
                    if (response.data.data.files.length > 0)
                        response.data.data.files.length > 0 &&
                            setPreview(response.data.data.files);
                    else setPreview();
                    setDepartments(response.data.data.departments_list);
                    setDepartmentsList(response.data.data.departments_list);
                    setIsActive(response.data.data.place.is_active);
                } else {
                    if (typeof response.data.errors === typeof "String") {
                        toast.error(response.data.errors);
                    } else {
                        response.data.errors.forEach((element) => {
                            toast.error(element);
                        });
                    }
                }
            })
            .catch((error) => {
                setLoading(false);
                toast.error("Error making API call:", error);
            });
    };

    // #region load deps
    const getDepartmentsAPI = () => {
        setLoading(true);
        axios
            .get(
                serverConfig.server.url +
                apiConfig.api.getAPIs.getDepartmentsForPlace +
                placeID +
                "/departments",
                { headers }
            )
            .then((response) => {
                setLoading(false);
                if (response.data.status === "success") {
                    setDepartments(response.data.data.departments_list);
                    // setDepartmentsList(response.data.data.departments_list);
                    if (
                        response.data.data.other_departments &&
                        response.data.data.other_departments.length > 0
                    ) {
                        setAllDepartments(response.data.data.other_departments);
                    } else {
                        setAllDepartments();
                    }
                    // pagination
                    // setPaginationElem();
                    // for (let i = 1; i <= response.data.data.page_count; i++) {
                    //   setPaginationElem((prevPaginationElem) => (
                    //     <>
                    //       {prevPaginationElem}
                    //       <li
                    //         className={"page-item" + (currentPage == i ? " active" : "")}
                    //       >
                    //         <a
                    //           className="page-link"
                    //           href="#"
                    //           onClick={() => {
                    //             setCurrentPage(i);
                    //           }}
                    //         >
                    //           {i}
                    //         </a>
                    //       </li>
                    //     </>
                    //   ));
                    // }
                } else {
                    if (typeof response.data.errors === typeof "String") {
                        toast.error(response.data.errors);
                    } else {
                        response.data.errors.forEach((element) => {
                            toast.error(element);
                        });
                    }
                }
            })
            .catch((error) => {
                setLoading(false);
                toast.error("Error making API call:", error);
            });
    };
    // #endregion

    // #region assign dep to place
    const changeDepartment = (department) => {
        if (department.length == 0) {
            setDepartment({ id: null, title: null, biography: null });
        } else {
            setDepartment({
                id: department.id,
                title: department.title,
                biography: department.biography,
            });
        }
    };
    // #endregion

    // #region add dep from place
    const addDepartmentAPI = () => {
        setLoading(true);
        axios
            .post(
                serverConfig.server.url + apiConfig.api.addAPIs.addDepartmentPlace,
                {
                    place_id: placeID,
                    department_id: department.id,
                    phone: departmentPhone,
                    biography: departmentBio,
                },
                {
                    headers,
                }
            )
            .then((response) => {
                setLoading(false);
                if (response.data.status === "success") {
                    toast.success(response.data.message);
                    getPlaceProfileAPI();
                    getDepartmentsAPI();
                } else {
                    if (typeof response.data.errors === typeof "String") {
                        toast.error(response.data.errors);
                    } else {
                        response.data.errors.forEach((element) => {
                            toast.error(element);
                        });
                    }
                }
            })
            .catch((error) => {
                setLoading(false);
                toast.error("Error making API call:", error);
            });
    };
    // #endregion

    const refreshDepartmentList = () => {
        getPlaceProfileAPI();
        getDepartmentsAPI();
    };

    const loadPlaceDepartmentData = (department) => {
        setDepartmentEdit({
            id: department.id,
            title: department.title,
            biography: department.biography,
            phone: department.phone,
        });
        setModalEditDepartmentPlaceShow(true);
    };
    const updateDepartmentPlace = () => {
        setLoading(true);
        axios
            .post(
                serverConfig.server.url +
                apiConfig.api.updateAPIs.updateDepartmentPlace,
                {
                    place_id: placeID,
                    department_id: departmentEdit.id,
                    biography: departmentEdit.biography,
                    phone: departmentEdit.phone,
                },
                {
                    headers,
                }
            )
            .then((response) => {
                setLoading(false);
                if (response.data.status === "success") {
                    toast.success(response.data.message);

                    // Close the modal after updating the department place
                    setModalEditDepartmentPlaceShow(false);
                    // props.onSuccess();
                } else {
                    if (typeof response.data.errors === typeof "String") {
                        toast.error(response.data.errors);
                    } else {
                        response.data.errors.forEach((element) => {
                            toast.error(element);
                        });
                    }
                }
            })
            .catch((error) => {
                setLoading(false);
                toast.error("Error making API call:", error);
            });
    };

    useEffect(() => {
        if (placePhoto) {
            // create the preview
            const objectUrl = URL.createObjectURL(placePhoto.target.files[0]);
            setPreview(objectUrl);

            // free memory when ever this component is unmounted
            return () => URL.revokeObjectURL(objectUrl);
        }
    }, [placePhoto]);

    useEffect(() => {

        const checkLoginStatus = async () => {

            setLoading(true);

            try {

                const loggedIn = await IsLogin();
                setLogIn(loggedIn !== false);

                if (!token && tokenLocal) {
                    dispatch(setUser({ token: tokenLocal, roles: loggedIn }));
                }

                if (loggedIn === false || loggedIn === "error api") {

                    localStorage.getItem("FullName") && localStorage.removeItem("FullName");
                    localStorage.getItem("mobile") && localStorage.removeItem("mobile");
                    localStorage.getItem("token") && localStorage.removeItem("token");
                    localStorage.setItem("callBackURL", window.location.pathname + window.location.search);
                    navigate("/login");

                } stateAPI();

            } catch (error) {
                console.error("Error checking login status:", error);
            }
            finally { setLoading(false) }
        };

        checkLoginStatus();

    }, []);

    // pagination
    useEffect(() => {
        getPlacesAPI();
    }, [currentPage]);

    useEffect(() => {
        setCurrentPage(1);
        // getPlacesAPI();
    }, [searchValue, perPage]);

    useEffect(() => {
        if (clearData) {
            setPlaceName("");
            setpazirexPatientServiceAmount("");
            setpazirexProviderServiceAmount("");
            setBiography("");
            setPreview();
            setPlaceType("");
            setPlaceID("");
            setAddress("");
            setTechnicalPhoneNumber("");
            setIsActive(0);
            setSelectedCity("");
            setSelectedProvince("");
            setSelectedDeposit("");
            setClearData(false);
        }
    }, [clearData]);

    useEffect(() => {
        // setSelectedCity("");
    }, [selectedProvince]);

    useEffect(() => {
        if (editing) {
            getPlaceProfileAPI();
            getDepartmentsAPI();
        }
    }, [editing, placeID]);

    useEffect(() => {
        // Focus on the department search input when the modal is opened
        if (departmentSearchInputRef.current) {
            departmentSearchInputRef.current.focus();
        }
    }, []);

    useEffect(() => {
        if (pl) {
            setEditing(true);
            setPlaceID(pl);
        }
    }, [pl]);

    return (
        <div className="d-flex row pt-3">
            <div>
                {
                    loading
                        ?
                        <div className="tw-space-y-3">
                            <CreatePlaceSkt />
                            <PlaceSkt />
                        </div>
                        :
                        <>
                            {
                                logIn
                                &&
                                (haveAccess(roles, "place_add") || haveAccess(roles, "place_edit"))
                                &&
                                <div className="card card-box-shadow border-0 mb-3">
                                    <div className="card-body d-flex row">
                                        <h5>ثبت مرکز درمانی</h5>
                                        {/* preview image */}
                                        {preview ? (
                                            <div className="d-flex col my-2 col-12 position-relative">
                                                <img
                                                    className="w-100 object-fit-cover"
                                                    height={350}
                                                    src={preview}
                                                />
                                                <div
                                                    className="card position-absolute border-0 delete-card p-2"
                                                    onClick={() => {
                                                        setPlacePhoto();
                                                        setPreview();
                                                    }}
                                                >
                                                    <DeleteIcon width={24} />
                                                </div>
                                            </div>
                                        ) : (
                                            <div className="d-flex col my-2 col-12">
                                                <img
                                                    className="w-100 object-fit-cover"
                                                    height={350}
                                                    src={PlaceImgNotFound}
                                                />
                                            </div>
                                        )}

                                        {/* select image */}
                                        <div className="d-flex col flex-column my-2 col-12">
                                            <div className="d-flex">
                                                <input
                                                    // className={`form-control ${preview?"d-none":""}`}
                                                    className="form-control"
                                                    type="file"
                                                    id="formFile"
                                                    accept=".png,.jpg,.jpeg,.svg"
                                                    onChange={(e) => {
                                                        placePhotoChangeHandler(e);
                                                    }}
                                                />
                                                {/* <button className="btn btn-outline-danger p-1">
                    <PlaylistRemoveIcon width={24} />
                  </button> */}
                                            </div>
                                            <span className="text-secondary fs-14 fw-normal">
                                                حداکثر حجم مجاز عکس 5 مگابایت میباشد
                                            </span>
                                        </div>

                                        {/* name */}
                                        <div className="d-flex col my-2 col-lg-6 col-12">
                                            <input
                                                className="form-control"
                                                type="text"
                                                placeholder="نام مرکز درمانی"
                                                value={placeName}
                                                onChange={(e) => {
                                                    placeNameChangeHandler(e.target.value);
                                                }}
                                            />
                                        </div>

                                        <div className="d-flex col my-2 col-lg-6 col-12">
                                            <div
                                                className="background-bootstrap-gray-100 align-items-center border-radius-8 w-100 d-flex">
                                                <label
                                                    className="form-check-label ms-2 w-100 p-2 px-1"
                                                    htmlFor="activePlace"
                                                >
                                                    فعال بودن مرکز درمانی
                                                </label>

                                                <div className="form-check form-switch">
                                                    <input
                                                        className="form-check-input"
                                                        type="checkbox"
                                                        id="activePlace"
                                                        onChange={() => {
                                                            if (isActive == 1) {
                                                                setIsActive(0);
                                                            } else {
                                                                setIsActive(1);
                                                            }
                                                        }}
                                                        checked={isActive == 1 ? true : false}
                                                    />
                                                </div>
                                            </div>
                                        </div>

                                        {/* Province Dropdown */}
                                        <div className="d-flex col my-2 col-12 col-lg-6">
                                            <select
                                                className="form-select"
                                                aria-label="استان"
                                                value={selectedProvince}
                                                onChange={(e) => {
                                                    setSelectedProvince(e.target.value);
                                                }}
                                            >
                                                <option value="" disabled>
                                                    استان را انتخاب کنید
                                                </option>
                                                {provinces &&
                                                    provinces.map((e) => (
                                                        <option key={e.id} value={e.id}>
                                                            {e.name}
                                                        </option>
                                                    ))}
                                            </select>
                                        </div>

                                        {/* City Dropdown */}
                                        <div className="d-flex col my-2 col-12 col-lg-6">
                                            <select
                                                className="form-select"
                                                aria-label="شهر"
                                                value={selectedCity && selectedProvince ? selectedCity : ""}
                                                onChange={(e) => {
                                                    setSelectedCity(e.target.value);
                                                }}
                                            >
                                                <option value="" disabled>
                                                    شهر را انتخاب کنید
                                                </option>

                                                {cities &&
                                                    selectedProvince &&
                                                    cities
                                                        .filter((e) => e.province_id == selectedProvince)
                                                        .map((e) => (
                                                            <option key={e.id} value={e.id}>
                                                                {e.name}
                                                            </option>
                                                        ))}
                                            </select>
                                        </div>

                                        {/* address */}
                                        <div className="d-flex col my-2 col-12">
                                            <input
                                                className="form-control"
                                                type="text"
                                                placeholder="آدرس دقیق"
                                                value={address}
                                                onChange={(e) => {
                                                    addressChangeHandler(e.target.value);
                                                }}
                                            />
                                        </div>

                                        {/* tech phone number */}
                                        <div className="d-flex col my-2 col-12 col-lg-6">
                                            <input
                                                className="form-control"
                                                type="text"
                                                placeholder="تلفن تماس"
                                                value={technicalPhoneNumber}
                                                onChange={(e) => {
                                                    technicalPhoneNumberChangeHandler(e.target.value);
                                                }}
                                            />
                                        </div>

                                        {/* Type */}
                                        <div className="d-flex col my-2 col-12 col-lg-6">
                                            <select
                                                className="form-select"
                                                aria-label="نوع مرکز درمانی"
                                                value={placeType}
                                                onChange={(e) => {
                                                    setPlaceType(e.target.value);
                                                }}
                                            >
                                                <option value="" disabled>
                                                    نوع مرکز درمانی را انتخاب کنید
                                                </option>
                                                {constData.placeTypes &&
                                                    constData.placeTypes.map((e, index) => (
                                                        <option key={index} value={e.id}>
                                                            {e.name}
                                                        </option>
                                                    ))}
                                            </select>
                                        </div>

                                        {/* biography */}
                                        <div className="d-flex col my-2 col-12">
                                            <textarea
                                                className="form-control"
                                                placeholder="توضیحات مرکز (اختیاری)"
                                                value={biography ? biography : ""}
                                                onChange={(e) => {
                                                    setBiography(e.target.value);
                                                }}
                                            />
                                        </div>
                                        <div className="d-flex col my-2 col-lg-6 col-12">
                                            <select
                                                className="form-select"
                                                aria-label="درصد بیعانه"
                                                value={selectedDeposit}
                                                onChange={(e) => setSelectedDeposit(e.target.value)}
                                            >
                                                {depositOptions.map((option) => (
                                                    <option key={option.value} value={option.value} disabled={option.disabled}>
                                                        {option.label}
                                                    </option>
                                                ))}
                                            </select>
                                        </div>

                                        <div className="d-flex col my-2 col-lg-6 col-12">
                                            <input
                                                className="form-control"
                                                type="text"
                                                placeholder="هزینه خدمات پذیرکس برای بیمار"
                                                value={pazirexPatientServiceAmount}
                                                onChange={(e) => {
                                                    pazirexPatientServiceAmountChangeHandler(e.target.value)
                                                }}
                                            />
                                        </div>
                                        <div className="d-flex col my-2 col-lg-6 col-12">
                                            <input
                                                className="form-control"
                                                type="text"
                                                placeholder="هزینه خدمات پذیرکس برای پزشک"
                                                value={pazirexProviderServiceAmount}
                                                onChange={(e) => {
                                                    pazirexProviderServiceAmountChangeHandler(e.target.value)
                                                }}
                                            />
                                        </div>
                                        <div className="d-flex col my-2 col-lg-6 col-12">
                                            <input
                                                className="form-control"
                                                type="text"
                                                placeholder="هزینه کل ویزیت"
                                                value={totalVisitAmount}
                                                onChange={(e) => {
                                                    totalVisitAmountChangeHandler(e.target.value)
                                                }}
                                            />
                                        </div>

                                        <div className="d-flex col my-2 col-12">
                                            <div className="alert alert-warning p-1 fs-12 my-0">
                                                توضیحات در شناخت بهتر مخاطب از مکان و خدمات شما تاثیر بالایی
                                                دارد
                                            </div>
                                        </div>

                                        {/* Departments list */}
                                        {editing && (
                                            <>
                                                {allDepartments &&
                                                    haveAccess(roles, "place_department_add") && (
                                                        <div className="d-flex col my-2 col-12 col-lg-6">
                                                            <div className="d-flex row w-100 m-0">
                                                                <div
                                                                    className="btn btn-outline-active d-flex align-items-center"
                                                                    data-bs-toggle="modal"
                                                                    data-bs-target="#department-modal"
                                                                >
                                                                    اختصاص دپارتمان
                                                                    <img
                                                                        src={AddIcon}
                                                                        className="ms-auto"
                                                                        width={20}
                                                                        alt=""
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )}

                                                <div>
                                                    <div className="d-flex row g-3 mt-0">
                                                        {departmentsList &&
                                                            departmentsList.map((department, index) => {
                                                                if (department.in_use) {
                                                                    return (
                                                                        // <span
                                                                        //   key={department.id}
                                                                        //   className="d-flex btn border-1 border-iso-blue-300 color-iso-blue-300 rounded-pill p-1 ps-3 pe-2 py-1 me-1 mt-2 col col-auto bg-iso-blue-100 fs-12 align-items-center"
                                                                        //   onClick={handleClickOpen}
                                                                        // >
                                                                        //   {department.title}
                                                                        //   <span className="material-symbols-rounded fs-16 ms-2 me-0">
                                                                        //     remove
                                                                        //   </span>

                                                                        //   <Dialog
                                                                        //     open={open}
                                                                        //     onClose={handleClose}
                                                                        //     aria-labelledby="alert-dialog-title"
                                                                        //     aria-describedby="alert-dialog-biography"
                                                                        //   >
                                                                        //     <DialogTitle id="alert-dialog-title">
                                                                        //       {"Use Google's location service?"}
                                                                        //     </DialogTitle>
                                                                        //     <DialogContent>
                                                                        //       <DialogContentText id="alert-dialog-biography">
                                                                        //         Let Google help apps determine location. This
                                                                        //         means sending anonymous location data to
                                                                        //         Google, even when no apps are running.
                                                                        //       </DialogContentText>
                                                                        //     </DialogContent>
                                                                        //     <DialogActions>
                                                                        //       <Button onClick={handleClose}>Disagree</Button>
                                                                        //       <Button onClick={handleClose} autoFocus>
                                                                        //         Agree
                                                                        //       </Button>
                                                                        //     </DialogActions>
                                                                        //   </Dialog>
                                                                        // </span>
                                                                        <div key={index} className="col-lg-4 col-12">
                                                                            <DepartmentPlaceCard
                                                                                placeId={placeID}
                                                                                placeTitle={placeName}
                                                                                departmentId={department.id}
                                                                                departmentTitle={department.title}
                                                                                files={department.files}
                                                                                departmentBio={department.biography}
                                                                                departmentPhone={department.phone}
                                                                                alldata={department}
                                                                                onSuccess={refreshDepartmentList}
                                                                                onEditModal={() => {
                                                                                    loadPlaceDepartmentData(department);
                                                                                }}
                                                                            />
                                                                        </div>
                                                                    );
                                                                } else {
                                                                    return (
                                                                        <div key={index} className="col-lg-4 col-12">
                                                                            <DepartmentPlaceCard
                                                                                placeId={placeID}
                                                                                placeTitle={placeName}
                                                                                departmentId={department.id}
                                                                                departmentTitle={department.title}
                                                                                files={department.files}
                                                                                departmentBio={department.biography}
                                                                                departmentPhone={department.phone}
                                                                                alldata={department}
                                                                                onSuccess={refreshDepartmentList}
                                                                                onEditModal={() => {
                                                                                    loadPlaceDepartmentData(department);
                                                                                }}
                                                                            />
                                                                        </div>
                                                                    );
                                                                }
                                                            })}
                                                    </div>
                                                </div>
                                            </>
                                        )}

                                        {/* Button */}
                                        <div className="d-flex col my-2 col-12">
                                            {editing ? (
                                                // <button
                                                //   type="button"
                                                //   className="btn btn-primary w-100"
                                                //   onClick={placeUpdateAPI}
                                                // >
                                                //   ویرایش مرکز درمانی
                                                // </button>
                                                <>
                                                    {haveAccess(roles, "place_edit") && (
                                                        <div className="d-flex col-auto">
                                                            <button
                                                                type="button"
                                                                className={`btn btn-link color-bootstrap-regular-danger text-decoration-none w-100 px-4 ms-12px fw-medium${loading ? " disabled" : ""
                                                                    }`}
                                                                onClick={placeDeleteAPI}
                                                            >
                                                                حذف
                                                            </button>
                                                        </div>
                                                    )}

                                                    <div className="d-flex col">
                                                        <button
                                                            type="button"
                                                            // disabled={loadingStore}
                                                            className="btn btn-outline-primary w-100 mx-12px fw-medium"
                                                            onClick={() => {
                                                                setClearData(true);
                                                                setEditing(false);
                                                                navigate("/place-store");
                                                            }}
                                                        >
                                                            انصراف
                                                        </button>
                                                    </div>

                                                    <div className="d-flex col">
                                                        <button
                                                            type="button"
                                                            className={`btn btn-primary w-100 me-12px fw-medium${loading ? " disabled" : ""
                                                                }`}
                                                            onClick={placeUpdateAPI}
                                                        >
                                                            تایید
                                                        </button>
                                                    </div>
                                                </>
                                            ) : (
                                                <button
                                                    type="button"
                                                    className={`btn btn-primary w-100 ${loading ? " disabled" : ""
                                                        }`}
                                                    onClick={placeStoreAPI}
                                                >
                                                    ثبت مرکز درمانی
                                                </button>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            }
                            <div>

                                <div className="card card-box-shadow border-0 mb-3">
                                    <div className="card-body d-flex flex-column">
                                        <div className="d-flex align-items-center mb-2">
                                            <p className="col fs-18 fw-medium w-auto m-0">
                                                لیست مراکز درمانی
                                            </p>
                                            <div className="d-flex w-auto">
                                                <input
                                                    className="form-control ms-1 col"
                                                    type="text"
                                                    placeholder="جستجوی نام مکان"
                                                    value={searchValue}
                                                    onChange={(e) => {
                                                        setSearchValue(e.target.value);
                                                    }}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className="d-flex row g-3 mx-auto">
                                    {places?.map((place, index) => (
                                        <div className="col-lg-6 col-12" key={place.id}>
                                            <PlaceCard
                                                key={index}
                                                files={place.files}
                                                title={place.title}
                                                province_title={place.province_title}
                                                city_title={place.city_title}
                                                id={place.id}
                                            />
                                        </div>
                                    ))}
                                    <nav aria-label="Page navigation example">
                                        <ul className="pagination">
                                            {currentPage !== 1 && (
                                                <li className="page-item">
                                                    <a
                                                        className="page-link"
                                                        disabled
                                                        href="#"
                                                        aria-label="Previous"
                                                        onClick={() => {
                                                            setCurrentPage(currentPage - 1);
                                                            scrollToTop();
                                                        }}
                                                    >
                                                        <span aria-hidden="true">&laquo;</span>
                                                    </a>
                                                </li>
                                            )}
                                            {paginationElem}
                                            {pageCount != currentPage && (
                                                <li className="page-item">
                                                    <a
                                                        className="page-link"
                                                        disabled
                                                        href="#"
                                                        aria-label="Next"
                                                        onClick={() => {
                                                            setCurrentPage(currentPage + 1);
                                                            scrollToTop();
                                                        }}
                                                    >
                                                        <span aria-hidden="true">&raquo;</span>
                                                    </a>
                                                </li>
                                            )}
                                        </ul>
                                    </nav>
                                </div>

                            </div>
                        </>
                }

            </div>
            {/* select department modal */}
            <div
                className="modal fade"
                id="department-modal"
                tabIndex="-1"
                aria-labelledby="department-modal-label"
                aria-hidden="true"
            >
                <div className="modal-dialog modal-dialog-scrollable">
                    <div className="modal-content">
                        <div className="modal-header border-bottom mx-0 py-2">
                            <ArrowRightAltIcon
                                className="color-bootstrap-gray-800"
                                width={24}
                                height={24}
                                type="button"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            />
                            <input
                                type="text"
                                className="form-control border-0 shadow-none w-100 color-iso-gray"
                                id="department-search-input"
                                autoFocus={true}
                                placeholder="انتخاب دپارتمان ..."
                                value={departmentSearch}
                                onChange={(e) => setDepartmentSearch(e.target.value)}
                                ref={departmentSearchInputRef} // Assign the ref to the input field
                            />
                        </div>

                        <div className="modal-body">
                            {/* <button
                className="btn btn-light w-100 d-flex align-items-start my-2"
                data-bs-dismiss="modal"
                onClick={() =>
                  changeDepartment({ id: null, title: null, biography: null })
                }
              >
                همه دپارتمان ها
              </button> */}
                            <div className="d-flex flex-column align-items-start">
                                {allDepartments &&
                                    allDepartments
                                        .filter((e) => e.title.includes(departmentSearch))
                                        .map((department, index) => (
                                            <button
                                                className="btn btn-light w-100 d-flex align-items-start my-2"
                                                data-bs-toggle="modal"
                                                data-bs-target="#detail-modal"
                                                key={index}
                                                onClick={() => {
                                                    setDepartmentBio(department.biography);
                                                    changeDepartment(department);
                                                }}
                                            >
                                                {department.title}
                                            </button>
                                        ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* add detail of department modal */}
            <div
                className="modal fade"
                id="detail-modal"
                tabIndex="-1"
                aria-labelledby="detail-modal-label"
                aria-hidden="true"
            >
                <div className="modal-dialog modal-dialog-scrollable">
                    <div className="modal-content">
                        <div className="modal-header border-bottom mx-0 py-2 color-bootstrap-gray-800">
                            <ArrowRightAltIcon
                                width={24}
                                height={24}
                                type="button"
                                data-bs-dismiss="modal"
                                aria-label="Close"
                            />
                            <span className="w-100">اطلاعات دپارتمان</span>
                        </div>
                        <div className="modal-body">
                            {/* Detail inputs */}

                            <div className="d-flex col mb-2 col-12">
                                <input
                                    className="form-control"
                                    type="mobile"
                                    placeholder="شماره تماس"
                                    value={departmentPhone ? departmentPhone : ""}
                                    onChange={(e) => {
                                        setDepartmentPhone(e.target.value);
                                    }}
                                />
                            </div>

                            <div className="d-flex col my-2 col-12">
                                <textarea
                                    className="form-control"
                                    placeholder="توضیحات دپارتمان (اختیاری)"
                                    value={departmentBio ? departmentBio : ""}
                                    onChange={(e) => {
                                        setDepartmentBio(e.target.value);
                                    }}
                                />
                            </div>

                            <button
                                className="btn btn-primary w-100 d-flex align-items-center justify-content-center my-2"
                                data-bs-dismiss="modal"
                                onClick={() => {
                                    addDepartmentAPI();
                                    // setSelectedEducationId(education.id);
                                    // setSelectedEducationTitle(education.title);
                                    // if (selectedSpecialtyId) {
                                    //   setAddtolist(true);
                                    // }
                                    setDepartmentBio();
                                    setDepartmentPhone();
                                }}
                            >
                                افزودن دپارتمان {department.title}
                            </button>
                        </div>
                    </div>
                </div>
            </div>

            {/* edit department place detail modal */}
            <div
                className={`modal fade${modalEditDepartmentPlaceShow ? " show d-block" : ""
                    }`}
                // tabIndex="-1"
                aria-labelledby="edit-detail-modal-label"
                aria-hidden="false"
                role="dialog"
                onClick={(e) => {
                    if (!e.target.closest(".modal-content")) {
                        setModalEditDepartmentPlaceShow(false);
                    }
                }}
            >
                <div className="modal-dialog modal-dialog-scrollable">
                    <div className="modal-content">
                        <div className="modal-header border-bottom mx-0 py-2 color-bootstrap-gray-800">
                            <ArrowRightAltIcon
                                width={24}
                                height={24}
                                type="button"
                                onClick={() => {
                                    setModalEditDepartmentPlaceShow(false);
                                    setDepartmentEdit({
                                        id: null,
                                        title: null,
                                        biography: null,
                                        phone: null,
                                    });
                                }}
                            />
                            <span className="w-100">اطلاعات دپارتمان</span>
                        </div>
                        <div className="modal-body">
                            {/* Detail inputs */}

                            <div className="d-flex col mb-2 col-12">
                                <input
                                    className="form-control"
                                    type="mobile"
                                    placeholder="شماره تماس"
                                    value={departmentEdit.phone ? departmentEdit.phone : ""}
                                    onChange={(e) => {
                                        setDepartmentEdit((prevState) => ({
                                            ...prevState,
                                            phone: e.target.value,
                                        }));
                                    }}
                                />
                            </div>

                            <div className="d-flex col my-2 col-12">
                                <textarea
                                    className="form-control"
                                    placeholder="توضیحات دپارتمان (اختیاری)"
                                    value={
                                        departmentEdit.biography ? departmentEdit.biography : ""
                                    }
                                    onChange={(e) => {
                                        setDepartmentEdit((prevState) => ({
                                            ...prevState,
                                            biography: e.target.value,
                                        }));
                                    }}
                                />
                            </div>

                            <button
                                className="btn btn-primary w-100 d-flex align-items-center justify-content-center my-2"
                                onClick={() => {
                                    updateDepartmentPlace();
                                }}
                                disabled={loading}
                            >
                                ویرایش دپارتمان{" "}
                                {departmentEdit.title ? departmentEdit.title : ""}
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div
                className={`fade${modalEditDepartmentPlaceShow ? " modal-backdrop show" : ""
                    }`}
                onClick={() => {
                    setModalEditDepartmentPlaceShow(false);
                    setDepartmentEdit({
                        id: null,
                        title: null,
                        biography: null,
                        phone: null,
                    });
                }}
            />
        </div>
    );
};

export default PlaceStore;

{
    /* {places && (
                <div className="table-responsive">
                  <table className="table table-hover">
                    <thead className="table-light">
                      <tr>
                        <th scope="col">#</th>
                        <th scope="col"></th>
                        <th scope="col">نام مکان</th>
                        <th scope="col">استان</th>
                        <th scope="col">شهر</th>
                        <th scope="col" className="d-flex justify-content-center">
                          اعمال
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {places &&
                        places.map((place) => (
                          <tr className="fs-14" key={place.id}>
                            <th scope="row">{place.id}</th>
                            <td>
                              <img height={38} src={place.files} />
                            </td>
                            <td>{place.title}</td>
                            <td>{place.province_title}</td>
                            <td>{place.city_title}</td>
                            <td>
                              <div
                                className="btn btn-light material-symbols-rounded mx-1"
                                onClick={() => {
                                  setEditing(true);
                                  setPlaceID(place.id);
                                  scrollToTop();
                                }}
                              >
                                edit
                              </div>
                              <a
                                className="btn btn-light material-symbols-rounded mx-1"
                                href={`/place?${"pl=" + place.id}`}
                              >
                                visibility
                              </a>
                            </td>
                          </tr>
                        ))}
                    </tbody>
                  </table>
                  <nav aria-label="Page navigation example">
                    <ul className="pagination">
                      <li className="page-item">
                        <a
                          className="page-link"
                          href="#"
                          aria-label="Previous"
                          onClick={() => {
                            setCurrentPage(currentPage - 1);
                          }}
                        >
                          <span aria-hidden="true">&laquo;</span>
                        </a>
                      </li>
                      {paginationElem}
                      <li className="page-item">
                        <a
                          className="page-link"
                          href="#"
                          aria-label="Next"
                          onClick={() => {
                            setCurrentPage(currentPage + 1);
                          }}
                        >
                          <span aria-hidden="true">&raquo;</span>
                        </a>
                      </li>
                    </ul>
                  </nav>
                </div>
              )} */
}
